import { Component, OnInit } from '@angular/core';
import { Contendiente } from './interfaces/contendiente.interface';
import { ContendientesService } from './services/contendientes.service';
import copy from 'fast-copy';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Diputados Contendientes 2023';
  idioma = 'es';
  loading: boolean = false;
  contendientes: Contendiente[] = [];
  route: any;

  

  constructor(private api: ContendientesService, public _router: Router,
    private location: Location) {}

  ngOnInit() {

    
   
    this._router.events.subscribe( (val) => {
      if(this.location.path() != '') {
        this.route = this.location.path();
        // console.log('RUTA', this.route);
      }else {
        this.route = '/home'
        // console.log(this.route);
      }
    });
  } 

  

}
